export const GAME_SCROLL_SAVE_REQUEST = 'GAME_SCROLL_SAVE_REQUEST';
export const GAME_SCROLL_SAVE_SUCCESS = 'GAME_SCROLL_SAVE_SUCCESS';
export const GAME_SCROLL_USE_REQUEST = 'GAME_SCROLL_USE_REQUEST';
export const GAME_SCROLL_CLEAR = 'GAME_SCROLL_CLEAR';
export const GAME_TABS_SUCCESS = 'GAME_TABS_SUCCESS';
export const GAME_TABS_REQUEST = 'GAME_TABS_REQUEST';
export const GAME_ERROR = 'GAME_ERROR';

export const GAME_CLASS_APPS_REQUEST = 'GAME_CLASS_APPS_REQUEST';
export const GAME_CLASS_APPS_SUCCESS = 'GAME_CLASS_APPS_SUCCESS';

export const GAME_CLASS_LIST_REQURST = 'GAME_CLASS_LIST_REQURST';
export const GAME_CLASS_LIST_SUCCESS = 'GAME_CLASS_LIST_SUCCESS';

export const GAME_RANKS_TAB_REQUEST = 'GAME_RANKS_TAB_REQUEST';
export const GAME_RANKS_TAB_SUCCESS = 'GAME_RANKS_TAB_SUCCESS';

export const GAME_RANKS_MORE_LIST_REQUEST = 'GAME_RANKS_MORE_LIST_REQUEST';
export const GAME_RANKS_MORE_LIST_SUCCESS = 'GAME_RANKS_MORE_LIST_SUCCESS';

export const GET_GAME_CATEGORY_TAG = 'GET_GAME_CATEGORY_TAG';
export const SET_GAME_CATEGORY_TAG = 'SET_GAME_CATEGORY_TAG';
export const SET_SELECTED_TAG = 'SET_SELECTED_TAG';
export const DELETE_SELECTED_TAG = 'DELETE_SELECTED_TAG';
export const SET_GAME_CATEGORY_LIST = 'SET_GAME_CATEGORY_LIST';
export const SET_GAME_CODE = 'SET_GAME_CODE';
export const SET_SHOW_CATEGORY_TAG = 'SET_SHOW_CATEGORY_TAG';
export const GET_SEARCH_TAG = 'GET_SEARCH_TAG';
export const SET_SEARCH_TAG = 'SET_SEARCH_TAG';
export const CLEAR_TAG = 'CLEAR_TAG';
export const SET_SELECTED_A_TAG = 'SET_SELECTED_A_TAG';
export const GET_TAG_APP_LIST = 'GET_TAG_APP_LIST';
export const SET_APP_SORT = 'SET_APP_SORT';
export const SET_TAG_APP_LIST = 'SET_TAG_APP_LIST';
export const SET_LIST_LOADING = 'SET_LIST_LOADING';
// 8.6 负一屏
export const GAME_EXT_SCREEN_REQUEST = 'GAME_EXT_SCREEN_REQUEST';
export const GAME_EXT_SCREEN_SUCCESS = 'GAME_EXT_SCREEN_SUCCESS';
